<div
  class="analysts-desktop-content"
  [class.detail]="isDetail"
  [style.--d-gap.px]="gap()"
  [style.--d-ratings-max-height.px]="ratingsMaxHeight"
>
  @if (hasContent()) {
    <div class="desktop-grid">
      <div class="d-col d-col-left">
        @if (isFinnet()) {
          <ng-container
            [ngTemplateOutlet]="pair"
            [ngTemplateOutletContext]="{ title: 'Rating Konsens', legend: analystCountLegend() }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="statsRow"
            [ngTemplateOutletContext]="{
              size: 64,
              stroke: 10,
              labelClass: 'd-rating-label',
              valueClass: 'd-value-lg',
              unitSpan: true,
            }"
          ></ng-container>
        } @else {
          <app-v3-notch-card
            title="Rating Konsens"
            [source]="analystCountLegend()"
            [notchColor]="isPositive() ? 'var(--v3-positive)' : 'var(--v3-negative)'"
          >
            <ng-container
              [ngTemplateOutlet]="statsRow"
              [ngTemplateOutletContext]="{
                size: 32,
                stroke: 5,
                labelClass: 'nc-rating-label',
                valueClass: 'nc-value',
                unitSpan: false,
              }"
            ></ng-container>
          </app-v3-notch-card>
        }

        @if (avgTarget() !== null) {
          <div class="d-pair d-target-pair">
            <div class="d-target-legend-group">
              <span class="d-subtitle">Durchschnittliches Preisziel</span>
              @if (analystCountLegend()) {
                <span class="d-legend">{{ analystCountLegend() }}</span>
              }
            </div>
            <span
              class="d-value-lg"
              [class.positive]="targetIsPositive()"
              [class.negative]="!targetIsPositive()"
            >
              @if (avgTargetEuro() !== null) {
                <span class="count" [appCountUp]="avgTargetEuro()!" [decimals]="2"></span> €
              } @else {
                –
              }
            </span>
          </div>
        }

        @if (consensusHistory() && consensusHistory()!.length > 0) {
          <div class="d-chart-block">
            <app-price-line-chart
              [highTarget]="highTarget()"
              [avgTarget]="avgTarget()"
              [lowTarget]="lowTarget()"
              [currency]="targetCurrency()"
              [forceCurrency]="isZeroChartData() ? 'EUR' : undefined"
              [consensusHistory]="consensusHistory()"
              [currentPrice]="currentPrice()"
              [height]="chartHeight()"
              [primaryColor]="chartPrimaryColor()"
              [targetLabelColor]="chartTargetLabelColor()"
              [targetPositiveColor]="chartTargetPositiveColor()"
              [targetNegativeColor]="chartTargetNegativeColor()"
              [uniformGridColor]="true"
              [showAreaFill]="false"
              [animateIn]="true"
              [compactFonts]="!isFinnet()"
              [labelFont]="'Inter'"
            ></app-price-line-chart>
            <span class="d-legend d-graph-source">Quelle: {{ dataSources.TIPRANKS }}</span>
          </div>
        }
      </div>

      <div class="d-divider"></div>

      <div class="d-col d-col-right">
        @if (hasAnyRatings()) {
          @if (isDetail && !isFinnet()) {
            <div class="d-ratings-header">
              <span class="d-subtitle">{{ ratingsTitle() }}</span>
              <ng-container [ngTemplateOutlet]="ratingTabs"></ng-container>
            </div>
            <ng-container
              [ngTemplateOutlet]="pair"
              [ngTemplateOutletContext]="{ title: 'Ratings', legend: ratingsLegend() }"
            ></ng-container>
          } @else {
            <ng-container
              [ngTemplateOutlet]="pair"
              [ngTemplateOutletContext]="{ title: ratingsTitle(), legend: ratingsLegend() }"
            ></ng-container>
            <ng-container [ngTemplateOutlet]="ratingTabs"></ng-container>
          }
          @if (visibleRatings().length > 0) {
            <div
              class="d-ratings-list"
              [class.scrollable]="showAllRatings()"
              [appV3TabPanel]="activeRatingTab()"
            >
              @for (r of visibleRatings(); track ratingKey(r)) {
                <app-v3-analysts-rating-item
                  [rating]="r"
                  [isDetail]="isDetail"
                ></app-v3-analysts-rating-item>
              }
            </div>
          }
        }

        @if (theses().length > 0) {
          @if (showThesisHeader()) {
            <span class="d-subtitle d-thesis-header">{{
              showPositiveTheses()
                ? 'Positive Thesen der Analysten'
                : 'Negative Thesen der Analysten'
            }}</span>
          }
          <div class="d-thesis-list" [appV3TabPanel]="showPositiveTheses()">
            @for (thesis of theses(); track thesis.title) {
              <div class="d-thesis-item">
                <div class="d-thesis-item-title-row">
                  <span class="d-thesis-item-icon" [class.negative]="!showPositiveTheses()"></span>
                  <span class="d-thesis-item-title" [class.negative]="!showPositiveTheses()">{{
                    thesis.title
                  }}</span>
                </div>
                <p class="d-thesis-item-body">{{ thesis.text }}</p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<ng-template #pair let-title="title" let-legend="legend">
  <div class="d-pair">
    <span class="d-subtitle">{{ title }}</span>
    @if (legend) {
      <span class="d-legend">{{ legend }}</span>
    }
  </div>
</ng-template>

<ng-template
  #statsRow
  let-size="size"
  let-stroke="stroke"
  let-labelClass="labelClass"
  let-valueClass="valueClass"
  let-unitSpan="unitSpan"
>
  <div class="d-stats-row">
    <div class="d-gauge-block">
      <app-analyst-gauge
        [value]="gaugeValue()"
        [sellValue]="sellGaugeValue()"
        [size]="size"
        [strokeWidth]="stroke"
        positiveColor="var(--v3-positive)"
        negativeColor="var(--v3-negative)"
      ></app-analyst-gauge>
      <div class="d-rating-info">
        <span [class]="labelClass" [class.negative]="!isPositive()">{{ rating() }}</span>
        <span class="d-legend"
          >{{ buyCount() }} Buy · {{ holdCount() }} Hold · {{ sellCount() }} Sell</span
        >
      </div>
    </div>
    <div class="d-potential-block">
      <span
        [class]="valueClass"
        [class.positive]="potential() !== null && potential()! >= 0"
        [class.negative]="potential() !== null && potential()! < 0"
      >
        @if (potential() !== null) {
          {{ potential()! >= 0 ? '+' : ''
          }}<span class="count" [appCountUp]="potential()!" [decimals]="2"></span
          ><span [class.d-unit]="unitSpan">%</span>
        } @else {
          —
        }
      </span>
      <span class="d-legend">Potenzial zum Ø-Kursziel</span>
    </div>
  </div>
</ng-template>

<ng-template #ratingTabs>
  @if (isDetail && availableRatingTabs().length > 0) {
    <div class="d-rating-tabs">
      @for (category of availableRatingTabs(); track category) {
        <button
          type="button"
          class="d-rating-tab"
          [class.active]="activeRatingTab() === category"
          (click)="selectRatingTab(category)"
        >
          <span
            class="d-rating-tab-icon"
            [class.positive]="category === 'buy'"
            [class.negative]="category === 'sell'"
            [class.hold]="category === 'hold'"
          ></span>
          <span>{{ ratingTabLabel(category) }}</span>
          <span class="d-rating-tab-separator">·</span>
          <span>{{ ratingTabCount(category) }}</span>
        </button>
      }
    </div>
  }
</ng-template>
